import React, { MouseEvent } from 'react';
import {
  IconEmail,
  OutlineButtonLink,
  TextButton,
} from '@noths/polaris-client-ribbons-design-system';

import { PartnerCardImage } from 'src/components/molecules/PartnerCardImage';
import { Partner } from 'src/types';
import { PARTNER_CARD_TEST_ID } from '../constants';
import * as copy from '../constants/copy';
import { PartnerStorefrontLinkClickPayload } from '../tracking/events';
import * as styles from '../styles/PartnerCard.styles';

export interface PartnerCardProps {
  partner: Partner;
  onContactSellerClick: VoidFunction;
  onPartnerStorefrontLinkClick: (payload: PartnerStorefrontLinkClickPayload) => void;
}

export const PartnerCard = ({
  partner: { links, location, logo, name },
  onContactSellerClick,
  onPartnerStorefrontLinkClick,
}: PartnerCardProps) => {
  const partnerLinkHref = links?.[1]?.rel || '';

  const handleLinkClick = (
    type: PartnerStorefrontLinkClickPayload['event_label'],
    e?: MouseEvent,
  ) => {
    // Prevents double click event actions when clicking partner logo or name.
    e?.stopPropagation();

    onPartnerStorefrontLinkClick({
      destination_URL: partnerLinkHref,
      event_label: type,
      useEventCallback: type === 'Partner name',
    });
  };

  return (
    <section data-testid={PARTNER_CARD_TEST_ID}>
      <h2 css={styles.heading}>
        <a
          href={partnerLinkHref}
          css={styles.link}
          rel="nofollow"
          onClick={(e) => handleLinkClick('Partner name', e)}
        >
          <div css={styles.imageWrapper}>
            {logo && (
              <PartnerCardImage href={logo} onClick={(e) => handleLinkClick('Partner logo', e)} />
            )}
          </div>
          <div css={styles.copyWrapper}>
            <span css={styles.title}>{name}</span>
          </div>
        </a>
      </h2>
      <div css={[styles.copyWrapper]}>
        <p css={styles.location}>{location}</p>
        <TextButton
          onClick={(e) => {
            e.preventDefault();
            onContactSellerClick();
          }}
          css={styles.contactSeller}
        >
          <span css={styles.contactSellerIcon}>
            <IconEmail width={16} height={16} color={`var(--email-icon-color)`} />
          </span>
          {copy.CONTACT_SELLER}
        </TextButton>
        <OutlineButtonLink
          fullWidth
          className={copy.VISIT_SHOP_CLASSNAME}
          aria-label={copy.VISIT_SHOP}
          href={partnerLinkHref}
          onClick={() => handleLinkClick('Visit shop CTA')}
        >
          {copy.VISIT_SHOP}
        </OutlineButtonLink>
      </div>
    </section>
  );
};
